import type { HaloConfig, RGBA } from './guilloche';

const GOLD: RGBA       = { r: 197, g: 162, b: 88,  a: 1 };
const GOLD_MID: RGBA   = { r: 212, g: 183, b: 106, a: 1 };
const GOLD_LIGHT: RGBA = { r: 245, g: 215, b: 153, a: 1 };

export const HALO_CONFIGS: Record<string, HaloConfig> = {
  makarios: {
    rings: [
      {
        innerRadius: 0.42, outerRadius: 0.46, frequency: 1, amplitude: 0.18,
        waveform: 'hypo', color: { ...GOLD, a: 0.6 },
        lineWidth: 1.7, glowPasses: 5, glowSpread: 5, rotationSpeed: -0.048,
      },
      {
        innerRadius: 0.42, outerRadius: 0.46, frequency: 24, amplitude: 0.6,
        waveform: 'hypo', color: { ...GOLD_MID, a: 0.5 },
        lineWidth: 0.8, glowPasses: 2, glowSpread: 1.5, rotationSpeed: -0.015,
      },
      {
        innerRadius: 0.46, outerRadius: 0.50, frequency: 48, amplitude: 0.7,
        waveform: 'rose', color: { ...GOLD_LIGHT, a: 0.4 },
        lineWidth: 0.6, glowPasses: 2, glowSpread: 1, rotationSpeed: 0.01,
      },
    ],
    guillocheParams: [
      { R: 1.03, r: 0.41, d: 0.48, resolution: 3700, phase: 0.86, modFreq: 6, modDepth: 0.48 },
      { R: 0.83, r: 0.01, d: 0.30, resolution: 2500, phase: 0.4488, modFreq: 6, modDepth: 0.39 },
      { R: 0.88, r: 0.28, d: 0.10, resolution: 2000, phase: 0.6283, modFreq: 5, modDepth: 0.15 },
    ],
    guillocheScale: 0.41,
    guillocheColor: { r: 189, g: 167, b: 95, a: 0.15 },
    guillocheLineWidth: 1.2,
    guillocheBlendMode: 'screen',
    breatheSpeed: 0.46,
    breatheDepth: 0.015,
    fillColor: { r: 197, g: 162, b: 82, a: 0.45 },
    fillRadius: 0.54,
    fillBlendMode: 'screen',
    borderColor: { r: 190, g: 162, b: 88, a: 0.8 },
    borderWidth: 2.1,
    ringBlendMode: 'screen',
    globalRotationSpeed: 0.034,
  },

  makariosOriginal: {
    rings: [
      {
        innerRadius: 0.38, outerRadius: 0.42, frequency: 36, amplitude: 0.8,
        waveform: 'sin', color: { ...GOLD, a: 0.6 },
        lineWidth: 1, glowPasses: 3, glowSpread: 2, rotationSpeed: 0.02,
      },
      {
        innerRadius: 0.42, outerRadius: 0.46, frequency: 24, amplitude: 0.6,
        waveform: 'hypo', color: { ...GOLD_MID, a: 0.5 },
        lineWidth: 0.8, glowPasses: 2, glowSpread: 1.5, rotationSpeed: -0.015,
      },
      {
        innerRadius: 0.46, outerRadius: 0.50, frequency: 48, amplitude: 0.7,
        waveform: 'rose', color: { ...GOLD_LIGHT, a: 0.4 },
        lineWidth: 0.6, glowPasses: 2, glowSpread: 1, rotationSpeed: 0.01,
      },
    ],
    guillocheParams: [
      { R: 1.00, r: 0.22, d: 0.18, resolution: 3000, phase: 0, modFreq: 7, modDepth: 0.25 },
      { R: 0.95, r: 0.18, d: 0.14, resolution: 2500, phase: Math.PI / 7, modFreq: 13, modDepth: 0.20 },
      { R: 0.88, r: 0.28, d: 0.10, resolution: 2000, phase: Math.PI / 5, modFreq: 5, modDepth: 0.15 },
    ],
    guillocheScale: 0.35,
    guillocheColor: { ...GOLD, a: 0.15 },
    guillocheLineWidth: 0.5,
    guillocheBlendMode: 'screen',
    breatheSpeed: 0.3,
    breatheDepth: 0.015,
    fillColor: { ...GOLD, a: 0.03 },
    fillRadius: 0.48,
    fillBlendMode: 'source-over',
    borderColor: { ...GOLD, a: 0.8 },
    borderWidth: 1.5,
    ringBlendMode: 'screen',
    globalRotationSpeed: 0,
  },

  bruceLee: {
    rings: [
      {
        innerRadius: 0.43, outerRadius: 0.47, frequency: 69, amplitude: 0.81,
        waveform: 'rose', color: { ...GOLD, a: 0.6 },
        lineWidth: 1.1, glowPasses: 8, glowSpread: 5, rotationSpeed: -0.063,
      },
      {
        innerRadius: 0.35, outerRadius: 0.45, frequency: 74, amplitude: 0.27,
        waveform: 'rose', color: { ...GOLD_MID, a: 0.5 },
        lineWidth: 0.8, glowPasses: 5, glowSpread: 2.1, rotationSpeed: 0.003,
      },
    ],
    guillocheParams: [
      { R: 0.57, r: 0.38, d: 0.46, resolution: 3900, phase: 2.54, modFreq: 18, modDepth: 0.35 },
      { R: 1.05, r: 0.29, d: 0.18, resolution: 2700, phase: 0.96, modFreq: 6, modDepth: 0 },
      { R: 1.09, r: 0.28, d: 0.04, resolution: 2000, phase: 0.6283185307179586, modFreq: 6, modDepth: 0.15 },
    ],
    guillocheScale: 0.43,
    guillocheColor: { r: 226, g: 161, b: 68, a: 0.48 },
    guillocheLineWidth: 1.2,
    guillocheBlendMode: 'screen',
    breatheSpeed: 0.46,
    breatheDepth: 0.015,
    fillColor: { r: 202, g: 162, b: 65, a: 0.45 },
    fillRadius: 0.53,
    fillBlendMode: 'screen',
    borderColor: { r: 190, g: 162, b: 70, a: 0.8 },
    borderWidth: 2.1,
    ringBlendMode: 'screen',
    globalRotationSpeed: 0.034,
  },

  giordanoBruno: {
    rings: [
      {
        innerRadius: 0.40, outerRadius: 0.45, frequency: 42, amplitude: 0.65,
        waveform: 'hypo', color: { r: 160, g: 145, b: 110, a: 0.55 },
        lineWidth: 1.3, glowPasses: 4, glowSpread: 4, rotationSpeed: -0.025,
      },
      {
        innerRadius: 0.45, outerRadius: 0.49, frequency: 56, amplitude: 0.5,
        waveform: 'rose', color: { r: 180, g: 160, b: 120, a: 0.4 },
        lineWidth: 0.7, glowPasses: 3, glowSpread: 2, rotationSpeed: 0.018,
      },
    ],
    guillocheParams: [
      { R: 0.97, r: 0.31, d: 0.42, resolution: 3400, phase: 1.2, modFreq: 8, modDepth: 0.38 },
      { R: 0.85, r: 0.14, d: 0.22, resolution: 2600, phase: 0.72, modFreq: 11, modDepth: 0.28 },
      { R: 0.92, r: 0.25, d: 0.08, resolution: 2000, phase: 0.42, modFreq: 5, modDepth: 0.12 },
    ],
    guillocheScale: 0.40,
    guillocheColor: { r: 160, g: 145, b: 100, a: 0.18 },
    guillocheLineWidth: 1.0,
    guillocheBlendMode: 'screen',
    breatheSpeed: 0.28,
    breatheDepth: 0.012,
    fillColor: { r: 170, g: 150, b: 100, a: 0.35 },
    fillRadius: 0.52,
    fillBlendMode: 'screen',
    borderColor: { r: 160, g: 145, b: 100, a: 0.7 },
    borderWidth: 1.8,
    ringBlendMode: 'screen',
    globalRotationSpeed: 0.02,
  },

  tesla: {
    rings: [
      {
        innerRadius: 0.41, outerRadius: 0.46, frequency: 36, amplitude: 0.72,
        waveform: 'sin', color: { ...GOLD, a: 0.55 },
        lineWidth: 1.4, glowPasses: 6, glowSpread: 4.5, rotationSpeed: -0.042,
      },
      {
        innerRadius: 0.46, outerRadius: 0.50, frequency: 60, amplitude: 0.55,
        waveform: 'rose', color: { ...GOLD_LIGHT, a: 0.4 },
        lineWidth: 0.6, glowPasses: 3, glowSpread: 2, rotationSpeed: 0.028,
      },
    ],
    guillocheParams: [
      { R: 1.00, r: 0.33, d: 0.40, resolution: 3600, phase: 0.5, modFreq: 9, modDepth: 0.32 },
      { R: 0.90, r: 0.15, d: 0.25, resolution: 2800, phase: 1.1, modFreq: 12, modDepth: 0.22 },
      { R: 0.85, r: 0.27, d: 0.09, resolution: 2000, phase: 0.3, modFreq: 6, modDepth: 0.14 },
    ],
    guillocheScale: 0.42,
    guillocheColor: { r: 220, g: 195, b: 120, a: 0.2 },
    guillocheLineWidth: 1.1,
    guillocheBlendMode: 'screen',
    breatheSpeed: 0.38,
    breatheDepth: 0.018,
    fillColor: { r: 210, g: 185, b: 100, a: 0.4 },
    fillRadius: 0.53,
    fillBlendMode: 'screen',
    borderColor: { r: 200, g: 175, b: 95, a: 0.75 },
    borderWidth: 2.0,
    ringBlendMode: 'screen',
    globalRotationSpeed: 0.03,
  },

  fuller: {
    rings: [
      {
        innerRadius: 0.43, outerRadius: 0.47, frequency: 30, amplitude: 0.6,
        waveform: 'hypo', color: { ...GOLD_MID, a: 0.5 },
        lineWidth: 1.2, glowPasses: 4, glowSpread: 3, rotationSpeed: -0.02,
      },
      {
        innerRadius: 0.47, outerRadius: 0.51, frequency: 6, amplitude: 0.35,
        waveform: 'sin', color: { ...GOLD, a: 0.45 },
        lineWidth: 0.9, glowPasses: 2, glowSpread: 1.5, rotationSpeed: 0.015,
      },
    ],
    guillocheParams: [
      { R: 1.02, r: 0.35, d: 0.35, resolution: 3200, phase: 0.7, modFreq: 6, modDepth: 0.30 },
      { R: 0.88, r: 0.20, d: 0.20, resolution: 2400, phase: 0.9, modFreq: 5, modDepth: 0.18 },
    ],
    guillocheScale: 0.40,
    guillocheColor: { r: 185, g: 165, b: 100, a: 0.16 },
    guillocheLineWidth: 1.0,
    guillocheBlendMode: 'screen',
    breatheSpeed: 0.25,
    breatheDepth: 0.012,
    fillColor: { r: 190, g: 165, b: 90, a: 0.35 },
    fillRadius: 0.52,
    fillBlendMode: 'screen',
    borderColor: { r: 180, g: 158, b: 88, a: 0.7 },
    borderWidth: 1.8,
    ringBlendMode: 'screen',
    globalRotationSpeed: 0.018,
  },

  minimal: {
    rings: [
      {
        innerRadius: 0.44, outerRadius: 0.48, frequency: 24, amplitude: 0.5,
        waveform: 'sin', color: { ...GOLD, a: 0.5 },
        lineWidth: 1, glowPasses: 2, glowSpread: 2, rotationSpeed: 0.01,
      },
    ],
    guillocheParams: [
      { R: 1.00, r: 0.25, d: 0.15, resolution: 2000, phase: 0, modFreq: 0, modDepth: 0 },
    ],
    guillocheScale: 0.4,
    guillocheColor: { ...GOLD, a: 0.1 },
    guillocheLineWidth: 0.5,
    guillocheBlendMode: 'screen',
    breatheSpeed: 0.2,
    breatheDepth: 0.01,
    fillColor: { ...GOLD, a: 0.02 },
    fillRadius: 0.48,
    fillBlendMode: 'source-over',
    borderColor: { ...GOLD, a: 0.6 },
    borderWidth: 1,
    ringBlendMode: 'screen',
    globalRotationSpeed: 0,
  },
};
